import { atom } from 'recoil';

export const checkoutProgressAtom = atom<number>({
    key: 'checkoutProgress',
    default: 1
});
